import { PERFORMANCE_CODE_ENDPOINTS } from '@/core/collections/api/performance-code/performance-code.endpoints';
import { PerformanceCode } from '@/core/collections/api/performance-code/performance-code.interface';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PerformanceCodeKey } from './performance-code.enum';

export interface PerformanceCodeState {
   performance_codes: Array<PerformanceCode>;
}

const PerformanceCodeStore: Module<PerformanceCodeState, StoreState> = {
   namespaced: true,
   state: {
      performance_codes: [],
   },

   getters: {
      GET_WORK_HOURS_PERFORMANCE_CODE(state) {
         return state.performance_codes.find((performance_code) => performance_code.key === PerformanceCodeKey.WorkHours);
      },
   },

   mutations: {},

   actions: {
      async getAll({ state }) {
         const PERFORMANCE_CODE_RESPONSE = await api.get<ApiResource<PerformanceCode[]>>(PERFORMANCE_CODE_ENDPOINTS.GET_ALL(), {
            params: {
               per_page: 9999,
               'filter[is_chooseable_by_consultant]': true,
            },
         });

         state.performance_codes = PERFORMANCE_CODE_RESPONSE.data.data;
         return PERFORMANCE_CODE_RESPONSE.data.data;
      },
   },
};

export default PerformanceCodeStore;
